import { t } from 'i18next';

import { handleFailToast } from '../../api/utils/errorHandler';

export function endLoadingAndErrorToast(error?: any) {
  error && console.log({ error });
  const isBlockedUser = error?.code === 'BLOCKED';
  //   setLoading(false);
  if (isBlockedUser) {
    handleFailToast(t('general.contact_customer_support_error_message'));
  } else {
    handleFailToast(t('general.contact_customer_support_error_message'));
  }
}
